import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private _data: any = null;

  set(data: any) {
    this._data = data;
  }

  get(): any {
    return this._data;
  }

  clear() {
    this._data = null;
  }

  constructor() {}

  closeModal(modalId: string): void {
    const modalElement = document.getElementById(modalId);
    const modalBackdrop = document.querySelector('.modal-backdrop');
    if (modalElement) {
      modalElement.style.display = 'none';
      modalElement.classList.remove('show');
      modalElement.setAttribute('aria-hidden', 'true');
      modalBackdrop?.remove();
    }
  }

  openModal(modalId: string): void {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      modalElement.style.display = 'block';
      modalElement.classList.add('show');
      modalElement.removeAttribute('aria-hidden');

      // Agregar backdrop si no existe
      let modalBackdrop = document.querySelector('.modal-backdrop');
      if (!modalBackdrop) {
        modalBackdrop = document.createElement('div');
        modalBackdrop.className = 'modal-backdrop fade show';
        document.body.appendChild(modalBackdrop);
      }
    }
  }

  resetModal(modalId: string): void {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const clone = modalElement.cloneNode(true) as HTMLElement;
      modalElement.parentNode?.replaceChild(clone, modalElement);

      document.querySelector('.modal-backdrop')?.remove();

      clone.style.display = 'block';
      clone.classList.add('show');
      clone.removeAttribute('aria-hidden');

      const modalBackdrop = document.createElement('div');
      modalBackdrop.className = 'modal-backdrop fade show';
      document.body.appendChild(modalBackdrop);
    }
  }
}
